<template>
    <div id="mapContainer" class="map"></div>
</template>

<script>
    import mapboxgl from "mapbox-gl";
    import { mapGetters } from 'vuex';

    export default {
        name: "contactsMap",
        data() {
            return {
                accessToken: 'pk.eyJ1IjoiaWxhaWdhIiwiYSI6ImNrMXE2aml3bzExOWgzY282OG5uYWZzcGgifQ.1eFQ3g5cg8dHfmYF7DcgEg',
                map: null
            };
        },
        watch: {
            '$store.getters.currentCityPoint.lat': function () {
                mapboxgl.accessToken = this.accessToken;
                this.map = new mapboxgl.Map({
                    container: "mapContainer",
                    style: "mapbox://styles/mapbox/streets-v11",
                    center: [this.currentCityPoint.lon, this.currentCityPoint.lat],
                    pitch: 60,
                    bearing: -60,
                    zoom: 11,
                    antialias: true
                });

                const nav = new mapboxgl.NavigationControl();
                this.map.addControl(nav, "top-right");

                this.map.scrollZoom.disable();

                this.$http.get('/api/shops/contacts/map').then(res => {
                    res.data.forEach(point => {
                        new mapboxgl.Marker()
                            .setLngLat([point.lon, point.lat]).addTo(this.map);
                    });
                });
            }
        },
        computed: mapGetters(['currentCityPoint']),
    };
</script>
